
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/uncontested-divorce",
      function () {
        return require("private-next-pages/practice-areas/uncontested-divorce/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/uncontested-divorce"])
      });
    }
  